export default __webpack_public_path__ + "static/media/11_photo.bddef911.jpeg";